module.exports = __webpack_public_path__ + "assets/0a26c654e8a1fb94f4ccc5a5f213c389.jpg";